// Support hand-off used by the manage/cancel flows. Prefers the Intercom
// messenger when it's loaded on the page, falling back to a mailto.
export const SUPPORT_EMAIL = "info@hiiker.co";

type SupportWindow = {
  Intercom?: unknown;
  location: { href: string };
};

export function contactSupport(win: SupportWindow = window as unknown as SupportWindow): void {
  const intercom = win.Intercom;
  if (typeof intercom === "function") {
    (intercom as (command: string) => void)("show");
    return;
  }
  win.location.href = `mailto:${SUPPORT_EMAIL}`;
}
